 export const formatTime = (time: any) => {
 if(!time)return
        const time_part_array = time.split(":");
        let ampm = 'AM';


        if (time_part_array[0] >= 12)
           ampm = 'PM';

        if (time_part_array[0] > 12)
            time_part_array[0] = time_part_array[0] - 12;


//         return time_part_array[0] + ':' + time_part_array[1] + ':' + time_part_array[2] + ' ' + ampm;
        return time_part_array[0] + ':' + time_part_array[1] + ':' + time_part_array[2] + ' ' + ampm;
    }